<template>
  <a-spin :spinning="loading">
    <vxe-grid
        ref="xGrid"
        column-key
        class="column-sortable-grid"
        v-bind="gridOptions"
        :auto-resize="true"
        @cell-click="cellClick"
        @cell-dblclick="cellDbClick"
    >
      <template slot="default"></template>
    </vxe-grid>
  </a-spin>
</template>

<script>
import Vue from "vue";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
import {list} from "@/services/dataSource";

import VXETablePluginAntd from 'vxe-table-plugin-antd';
import 'vxe-table-plugin-antd/dist/style.css';

VXETable.use(VXETablePluginAntd);
import moment from 'moment';

Vue.use(VXETable);

/**
 * 如果value值有效(除了null/undefined/NaN之外的所有值)则返回value，否则返回defaultValue
 * @param value
 * @param defaultValue
 * @returns
 */
function valueOrDefault(value, defaultValue) {
  return typeof value === "undefined" || value === null || isNaN(value)
      ? defaultValue
      : value;
}

/**
 * 工厂方法，用来提供各种设置的默认值
 */
const factory = {
  /**
   * 生成一个序号列
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param width 50
   * @returns {}
   */
  makeColumnSeqDefault(width = 50) {
    return {type: "seq", title: '序号', width: width, align: "center"};
  },
  /**
   * 根据类型生成首列选择栏r>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param type 选择框内容 默认为checkbox
   * @returns {}
   */
  makeColumnDefault(type = 'checkbox') {
    if (type === 'radio') {
      return {type: "radio", field: '#', width: 50, align: "center"};
    } else {
      return {type: "checkbox", field: '#', width: 50, align: "center"};
    }
  },
  /**
   * 生成一个空的checkbox列定义<br>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param field 默认值为#
   * @returns {}
   */
  makeColumnCheckboxDefault(field = "#") {
    return {type: "checkbox", field: field, width: 50, align: "center"};
  },
  /**
   * 生成一个空的radio列定义<br>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param field 默认值为#
   * @returns {}
   */
  makeColumnRadioDefault(field = "#") {
    return {type: "radio", field: field, width: 50, align: "center"};
  },
  /**
   * 创建列定义
   * @param field 字段名，或者一个column对象（如果使用column对象，则只能传一个参数）
   * @param title 标题
   * @param width
   * @param align
   * @param resizable 是否可调整大小
   * @param formatter
   * @param type
   * @param sortable
   * @param filters
   * @returns {{formatter: null, field: *, resizable: boolean, width: (*|number), sortable: boolean, filters: *[], title: *, align: string, type: null, filterMultiple: boolean}|any}
   */
  makeColumn(
      field,
      title,
      width,
      align = "left",
      resizable = true,
      formatter = null,
      type = null,
      sortable = false,
      filters = ''
  ) {
    if (arguments.length === 1 && typeof field == "object" && field) {
      // 传入column object，则添加一些默认值
      return Object.assign(
          {
            field: field.field,
            title: field.title || field.field,
            width: field.width,
            resizable: valueOrDefault(field.resizable, true),
            sortable: valueOrDefault(field.sortable, false),
            headerAlign:'center'
          },
          field
      );
    } else {
      // 传入参数表
      return {
        field,
        title: title || field,
        width:
            width === null || typeof width === "undefined" ? width : width || 100,
        align,
        resizable,
        formatter,
        type,
        sortable,
        filters,
        filterMultiple: false,
        headerAlign:'center'
      };
    }
  },
  /**
   * 获取高级筛选列配置
   * @param columns 列信息
   * @param tmpFormConfig 配置
   * @returns
   */
  makeFormConfig(columns, tmpFormConfig) {
    columns = JSON.parse(JSON.stringify(columns));
    let formConfig = {
      titleWidth: 100,
      titleAlign: "right",
      data: {},
      items: [],
    };
    columns.map(function (e, index) {
      if (e.field === '#') {
        columns.splice(index, 1);
      }
    })
    const map = {};
    for (let index = 0; index < tmpFormConfig.length; index++) {
      const element = tmpFormConfig[index];
      map[element?.field] = element;
    }
    const itemRenderMap = {
      select: (options, title) => ({
        name: "ASelect",
        options,
        props: {placeholder: "请选择" + title},
      }),
      "multi-select": (options, title) => ({
        name: "ASelect",
        options,
        props: {
          mode: "multiple",
          placeholder: "请选择" + title,
        },
      }),
      switch: (options, title) => ({
        name: "ASwitch",
        options,
        props: {placeholder: "请选择" + title},
      }),
      number: (options, title) => ({
        name: "AInputNumber",
        options,
        props: {placeholder: "请输入" + title},
      }),
      dateRange: (options, title) => ({
        name: "ARangePicker",
        options,
        props: {placeholder: ["请选择" + title + "开始时间", "请选择" + title + "时间"]},
      }),
      date: (options, title) => ({
        name: "ADatePicker",
        options,
        props: {placeholder: "请选择" + title},
      }),
    };
    let searchNum = 0;
    for (let index = 0; index < columns.length; index++) {
      const col = columns[index];
      const c = map[col.field];
      if (!c) continue;
      searchNum++;
      const itemRender = itemRenderMap[c.type];
      formConfig.items.push({
        field: col.field,
        title: col.title,
        span: 8,
        folding: searchNum > 3,
        itemRender: itemRender
            ? itemRender(c.options, col.title)
            : {
              name: "AInput",
              props: {placeholder: "请输入" + col.title},
            },
        titleSuffix: (c.type === 'multi-select') ? {
          icon: 'fa fa-user-o'
        } : null
      });
      if (col.slots) {
        formConfig.items[formConfig.items.length - 1]['slots'] = col.slots
      }
      if (col.events) {
        formConfig.items[formConfig.items.length - 1]['events'] = col.events
      }
      formConfig.data[col.field] = c.type === "multi-select" || c.type === 'dateRange' ? [] : "";
    }

    formConfig.items.push({
      span: 8,
      align: "center",
      collapseNode: searchNum >3,
      itemRender: {
        name: "$buttons",
        children: [
          {props: {type: "submit", content: "搜索", status: "primary"}},
          {props: {type: "reset", content: "重置"}},
        ],
      },
    });
    return formConfig;
  },

  /**
   * 获取工具栏配置
   * @param buttons 按钮列表
   * @returns
   */
  makeToolbarConfig(buttons = {}) {
    return Object.assign({}, {
      addData: false,
      delData: false,
      reloadData: false,
      refresh: false,
      import: false,
      export: false,
      print: false,
      zoom: false,
      custom: false,
    }, buttons);
  },

  /**
   * 分页配置
   * @param defaultPageSize 如果分页列表不包含defaultPageSize则将其加入列表并排序
   * @returns {{pageSizes: number[], pageSize: number}}
   */
  makePagerConfig(defaultPageSize = 20) {
    let pageSizes = [10, 20, 50, 100, 200];
    if (pageSizes.indexOf(defaultPageSize) === -1) {
      pageSizes.push(defaultPageSize);
      pageSizes.sort();
    }
    return {
      pageSize: defaultPageSize,
      pageSizes: pageSizes,
    };
  },
};

/**
 * 组件定义
 */
export default {
  name: "XGrid",
  components: {},
  props: {
    id: String,
    columnResizable: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: true,
    },
    showHeaderOverflow: {
      type: Boolean,
      default: true,
    },
    showOverflow: {
      type: Boolean,
      default: true,
    },
    highlightHoverRow: {
      type: Boolean,
      default: true,
    },
    keepSource: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      default: 400,
    },
    /**
     * 数据集
     */
    data: Array,
    rowId: String,
    /**
     * 列定义
     */
    columns: Array,
    /**
     * 复选框设置<br>
     * checkbox列需要有对应的checkboxConfig才能显示field的值，如果checkbox column不需要显示值，可以指定一个不存在的field<br>
     * {
     *   labelField: 与Checkbox Column的field一致,
     *   reserve: true,
     *   highlight: true,
     *   range: true
     * }
     */
    checkboxConfig: Object,
    /**
     * 数据源API地址
     */
    url: String,
    /**
     * 分页配置<br>
     * { pageSize: NUMBER, pageSizes: [NUMBER, NUMBER, ...] }
     */
    pagerConfig: Object,
    /**
     * 查询表单配置<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/form<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/grid/api<br>
     * {
     *   titleWidth: NUMBER,
     *   titleAlign: 'right',
     *   data: {
     *   }
     *   items: [
     *     { field: FIELD, title: TITLE, span: NUMBER, itemRender: {name: '$input', props: {placeholder: PLACEHOLDER}} },
     *     ...
     *   ]
     * }
     */
    formConfig: Object,
    /**
     * 编辑设置，如果editable没有赋值，而且指定了editConfig也会打开编辑<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/edit<br>
    /**
     * 单元格双击时打开详情
     */
    cellDbClick: {
      type: Function,
      default() {
        return ''
      }
    },
    cellClick: {
      type: Function,
      default() {
        return ''
      }
    },
    /**
     * 需要给表格传递的其他参数
     */
    otherParams: {
      type: Object,
      default: null,
    },
  },
  data() {
    console.info("XGrid data =", this.data);
    return {
      loading: false,
      // 配置参考：
      // https://xuliangzhan_admin.gitee.io/vxe-table/#/grid/api
      // https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/basic
      gridOptions: {
        border: this.border,
        resizable: this.columnResizable,
        showHeaderOverflow: this.showHeaderOverflow,
        showOverflow: this.showOverflow,
        highlightHoverRow: this.highlightHoverRow,
        keepSource: this.keepSource,
        id: this.id,
        height: this.height,
        rowId: this.rowId || "id",
        url: this.url,
        customConfig: {
          storage: true,
          checkMethod: this.checkColumnMethod,
        },
        printConfig: this.printConfig,
        sortConfig: {
          trigger: "cell",
        },
        filterConfig: {
          remote: true,
        },
        pagerConfig: this.pagerConfig || factory.makePagerConfig(20),
        formConfig: this.formConfig,
        proxyConfig: {
          seq: true, // 启用动态序号代理
          sort: true, // 启用排序代理
          filter: true, // 启用筛选代理
          form: true, // 启用表单代理
          other: this.otherParams,
          props: {
            // 分页结果属性名
            // 参考代码：index.common.dev.js 20604
            // vxe-table/lib/grid/src/grid.js 739
            // https://gitee.com/xuliangzhan_admin/vxe-table/blob/v3/packages/grid/src/grid.js 546
            result: "data.list",
            total: "data.totalCount",
          },
          ajax: {
            // 接收 Promise 对象
            query: ({page, sort, filters, form}) => {
              let props = [], formData = {};
              for (let p in form) {
                props.push(p);
              }
              for (let f = 0; f < props.length; f++) {
                if (form[props[f]]) {
                  if (this.formConfig.items[f].itemRender.name === 'ASelect') {
                    /**多选框 */
                    if (this.formConfig.items[f].itemRender.props.mode &&
                        this.formConfig.items[f].itemRender.props.mode === 'multiple') {
                      formData['filter.inNumbers.' + props[f]] = form[props[f]].join(',');
                      // formData[props[f]] = form[props[f]].join(',');
                    } else {
                      /**单选框 */
                      formData['filter.eq.' + props[f]] = form[props[f]];
                      // formData[props[f]] = form[props[f]];
                    }
                  } else if (this.formConfig.items[f].itemRender.name === 'ASwitch') {
                    formData['filter.eq.' + props[f]] = form[props[f]];
                    // formData[props[f]] = form[props[f]];
                  } else if (this.formConfig.items[f].itemRender.name === 'AInputNumber') {
                    formData['filter.eq.' + props[f]] = form[props[f]];
                    // formData[props[f]] = form[props[f]];
                  } else if (this.formConfig.items[f].itemRender.name === 'ARangePicker') {
                    if(form[props[f]][0]&&form[props[f]][1]){
                      formData['filter.dateRange.' + props[f]] = moment(form[props[f]][0]).format('YYYY-MM-DD') + '~' + moment(form[props[f]][1]).format('YYYY-MM-DD');
                    }
                    // formData[props[f]] = moment(form[props[f]][0]).format('YYYY-MM-DD') + '~' + moment(form[props[f]][1]).format('YYYY-MM-DD');
                  } else if (this.formConfig.items[f].itemRender.name === 'ADatePicker') {
                    if(form[props[f]]){
                      formData['filter.eq.' + props[f]] = moment(form[props[f]], 'YYYY-MM-DD');
                    }
                    // formData[props[f]] = moment(form[props[f]], 'YYYY-MM-DD');
                  } else {
                    formData['filter.like.' + props[f]] = form[props[f]].replace(/(^\s*)|(\s*$)/g, "");
                    // formData[props[f]] = form[props[f]]
                  }
                }
              }
              // 处理排序条件
              const queryParams = Object.assign(
                  {
                    sort: sort.property,
                    order: sort.order,
                  },
                  formData,
                  {
                    page: page.currentPage,
                    limit: page.pageSize,
                  }
              );
              // 处理筛选条件
              filters.forEach(({property, values}) => {
                queryParams[property] = values.join(",");
              });
              if (this.otherParams && typeof this.otherParams === 'object') {
                Object.assign(queryParams, this.otherParams)
              }
              return list(this.url, queryParams).catch(e => {
                this.$message.error(e.msg);
                if (e.code === 401) {
                  setTimeout(() => {
                    this.$router.replace('/login');
                  }, 1000)
                }
              });
            },
          },
        },
        columns: this.columns,
        checkboxConfig: this.checkboxConfig,
      },

    };
  },
  methods: {
    /**
     * 获取列表数据
     *  用于有自定义数据时如何处理
     */
    checkColumnMethod({column}) {
      return !["nickname", "role"].includes(column.property);
    },
    refresh() {
      this.$refs.xGrid.commitProxy("query");
    },
    reloadData() {
      this.refresh();
    },
    getSelectData(type) {
      let selectRecords;
      if (type === 'radio') {
        selectRecords = this.$refs.xGrid.getRadioRecord();
      } else if (type === 'checkbox') {
        selectRecords = this.$refs.xGrid.getCheckboxRecords();
      }
      this.$emit('returnForm', selectRecords);
      this.clearTable();
    },
    clearTable() {
      this.$refs.xGrid.clearAll();
    }
  },
  factory: factory,
  watch: {
    formConfig() {
      this.gridOptions.formConfig = this.formConfig;
    },
  },
};
</script>

<style scoped>
.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-ghost,
.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-chosen {
  background-color: #dfecfb;
}

.column-sortable-grid .vxe-header--row .vxe-header--column.col--fixed {
  cursor: no-drop;
}
</style>
